import React, { useState } from "react";
import PropTypes from "prop-types";
import RepoItem from "./RepoItem";

const INITIAL_COUNT = 6;

const Repos = ({ repos }) => {
  const [showAll, setShowAll] = useState(false);
  const displayed = showAll ? repos : repos.slice(0, INITIAL_COUNT);
  const hasMore = repos.length > INITIAL_COUNT;

  return (
    <div className="repos-section">
      <div className="repos-header">
        <h2>Repositories</h2>
        {repos.length > 0 && (
          <span className="repos-count">{repos.length}</span>
        )}
      </div>
      {repos.length > 0 ? (
        <>
          <div className="repo-grid">
            {displayed.map((repo) => (
              <RepoItem repo={repo} key={repo.id} />
            ))}
          </div>
          {hasMore && (
            <button
              className="btn btn-light btn-block repo-toggle"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll
                ? "Show Less"
                : `Show All ${repos.length} Repositories`}
            </button>
          )}
        </>
      ) : (
        <p className="no-results">No repositories found</p>
      )}
    </div>
  );
};

Repos.propTypes = {
  repos: PropTypes.array.isRequired,
};

export default Repos;
